/**
 * Analytics utility — fire-and-forget event tracking.
 * If the analytics call fails, the app continues normally.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

export function trackEvent(event, payload = {}, userId = null) {
  try {
    const body = { event, payload, user_id: userId };
    // Use navigator.sendBeacon for page-unload safety, fall back to fetch
    const url = `${API_URL}/api/analytics/event`;
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    // Analytics must never break the app
  }
}

// Convenience helpers
export const trackAdView = (adId, extra = {}) =>
  trackEvent('ad_view', { ad_id: adId, ...extra });

export const trackAdOpen = (adId, extra = {}) =>
  trackEvent('ad_open', { ad_id: adId, ...extra });

export const trackFavoriteAdd = (adId, userId) =>
  trackEvent('favorite_add', { ad_id: adId }, userId);

export const trackChatOpen = (adId, sellerId, userId) =>
  trackEvent('chat_open', { ad_id: adId, seller_id: sellerId }, userId);

export const trackContactSeller = (adId, method, userId) =>
  trackEvent('contact_seller', { ad_id: adId, method }, userId);

export const trackSearchSubmit = (query, filters = {}) =>
  trackEvent('search_submit', { query, ...filters });

export const trackFilterApply = (filters) =>
  trackEvent('filter_apply', filters);

export const trackAdPublish = (adId, userId) =>
  trackEvent('ad_publish', { ad_id: adId }, userId);

export const trackAdMarkSold = (adId, userId) =>
  trackEvent('ad_mark_sold', { ad_id: adId }, userId);
